var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBoxThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DF0000",
  stroke: "#DF0000",
  strokeWidth: 0.5,
  d: "M31.571 2.429h-9.857v11.428h17.679a4 4 0 0 0-.197-.527l-3.705-8.357a4.29 4.29 0 0 0-3.92-2.544zm8 12.857H2.43v20a4.287 4.287 0 0 0 4.285 4.285h28.572a4.287 4.287 0 0 0 4.285-4.285v-20zM2.607 13.857h17.679V2.43h-9.857c-1.697 0-3.233 1-3.92 2.544L2.795 13.33a4 4 0 0 0-.197.527zM31.571 1a5.72 5.72 0 0 1 5.224 3.393l3.714 8.357c.321.732.491 1.518.491 2.321v20.215A5.72 5.72 0 0 1 35.286 41H6.714A5.72 5.72 0 0 1 1 35.286V15.07c0-.803.17-1.589.491-2.321l3.714-8.357A5.72 5.72 0 0 1 10.43 1h21.14z"
})));
export default SvgBoxThin;